<template>
  <v-container>
    <v-card>
      <p>
        File Input
      </p>
      <v-file-input class="ma-3" outlined @change="onFileChange"></v-file-input>

      <v-select outlined chip color="blue" class="ma-3" label="Question column" v-model="questionColumn" :items="columns"></v-select>
      <v-select outlined chip color="blue" class="ma-3" label="Answer column" v-model="answerColumn" :items="columns"></v-select>
      <v-text-field outlined chip color="blue" class="ma-3"  v-model="prependLearnMore" label="prepend learn more"></v-text-field>
      <v-select outlined chip color="blue" clearable class="ma-3" label="Learn more column" v-model="learnMoreColumn" :items="columns"></v-select>
      <v-spacer></v-spacer>
      <v-text-field outlined class="ma-3" label="deckId" v-model="deckId"></v-text-field>
      <v-btn class="ma-3" @click="writeContent" color="orange" rounded dark>Write Content</v-btn>
    </v-card>


  </v-container>

</template>
<script>
import Papa from 'papaparse'
import firebase from 'firebase'
import Obj from '@/objects.js'

export default {
  name: 'CSVImporter',
  data() {
    return {
      df: null,
      columns: [],
      deckId: null,
      answerColumn: null,
      questionColumn: null,
      learnMoreColumn: null,
      prependLearnMore: '',

    }
  },
  methods: {
    onFileChange(e) {
      if (e != null) {

        Papa.parse(e, {header: true, complete: t => {
          this.df = t.data
          if (t.data.length > 0 ){
            this.columns = Object.keys(t.data[0])
          }
          console.log(t)


          }
        })

      }
      else {
        return null
      }

    },
    writeContent() {
      if (this.deckId != null) {
        firebase.firestore().collection('decks').doc(this.deckId)
        .get().then(docRef => {
          if (docRef.exists) {
            return true
          }
          else {
            return false
          }
        }).then(n => {
          let batch = firebase.firestore().batch()
          let cardRef = firebase.firestore().collection('cards')

          this.df.forEach((item, index) => {



            let card = Obj.createNewCard('question_answer')
            card.deck = this.deckId


            card.question = item[this.questionColumn]
            card.answer = item[this.answerColumn]
            card.learnMore = this.prependLearnMore
            if (this.learnMoreColumn != null) {
              card.learnMore += item[this.learnMoreColumn]
            }

            console.log(card)
            batch.set(cardRef.doc(), card)



          })
          batch.commit()
          console.log("commited edit")

        })
      }

    }
  }
}

</script>
